<template>
  <div class="login_start without-header">
    <LoginNoMobPasswortVorhanden />
  </div>
  <Copyright />
</template>

<script>
// @ is an alias to /src
import LoginNoMobPasswortVorhanden from '@/components/LoginNoMobPasswortVorhanden.vue'
import Copyright from '@/components/copyright.vue'

export default {
  name: 'Home',
  components: {
    LoginNoMobPasswortVorhanden,
    Copyright,
  },
}
</script>
